export default {
      id: "icon-rolling-resistance-usage",
      viewBox: "0 0 212 213",
      url: "/" + "sprite.svg#icon-rolling-resistance",
      toString: function () {
        return this.url;
      }
    }